export const URL_MODES = {
  SEO_BAD: 1, // Use only parameters in the url. No sub paths. Pages chosen by 'page' paramter (BAD SEO)
  SEO_SEMI: 2, // Use only parameters in the detail view url (SEMI BAD SEO)
  SEO_GOOD: 3 // Default: Use normal url (GOOD SEO)
};

export const PAGE_NAMES = {
  QUICK_SEARCH: "quickSearch" as const,
  QUICK_SEARCH_USED: "quickSearchUsed" as const,
  QUICK_SEARCH_NEW: "quickSearchNew" as const,
  VEHICLE_LIST: "vehicleList" as const,
  VEHICLE_DETAIL: "vehicleDetail" as const,
  DETAIL_SEARCH: "detailSearch" as const,
  NOT_FOUND: "404" as const
} as const;
